import React, { useState, useEffect } from 'react';
import { Card, CardBody, Col, Row, Button } from 'reactstrap';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import ElectronicBillingHTTP from '../../../ElectronicBilling/api/ElectronicBillingHTTP';
import AlertModal from '../../../../shared/components/Modal';

const ElectronicBillingProvider = (props) => {
    const [providers, setProviders] = useState([]);
    const [provider, setProvider] = useState(null);
    const [FEResolution, setFEResolution] = useState(null);
    const [FEUser, setFEUser] = useState(null);
    const [FEPassword, setFEPassword] = useState(null);
    const [FEUrlEndpoint, setFEUrlEndpoint] = useState(null);
    const [errors,setErrors] = useState({});

    const [warningModal, setWarningModal] = React.useState(false);
    const [successModal, setSuccessModal] = React.useState(false);
    const [errorModal, setErrorModal] = React.useState(false);

    useEffect(() => {
        listProviders();
        actualProvider();
    }, []);

    const listProviders = async () => {
        let providers_list = await ElectronicBillingHTTP.getProviders();
        setProviders(providers_list);
    }

    const actualProvider = async () => {
        let actualProvider = await ElectronicBillingHTTP.getActualProvider();
        setProvider(actualProvider.id_factura_electronica_api);
        setFEResolution(actualProvider.resolucion_fe);
        setFEUrlEndpoint(actualProvider.url_api);

        if(actualProvider.usuario != undefined && actualProvider.usuario != null)
        {
            setFEUser(actualProvider.usuario.userFE.usuario);
        }
    }

    const handleChangeProvider = (value) => {
        setProvider(value);
    }

    const handleChangeFEResolution = (value) => {
        setFEResolution(value);
    }

    const handleChangeFEUser = (value) => {
        setFEUser(value);
    }

    const handleChangeFEPassword = (value) => {
        setFEPassword(value);
    }

    const cancelChangeProvider = (value) => {
        setWarningModal(false);
    }

    const validate = () => {
        var errors = {};
        var error = false;

        if (provider === "" || provider === undefined || provider === null) {
            errors.provider = "El Proveedor de Facturación Electronica es Obligatorio";
            error = true;
        }

        if (FEResolution === "" || FEResolution === undefined || FEResolution === null) {
            errors.FEResolution = "La Resolucion de Facturación es Obligatoria";
            error = true;
        }

        if(FEUrlEndpoint === "" || FEUrlEndpoint === undefined || FEUrlEndpoint === null)
        {
            errors.FEUrlEndpoint = "La URL de Facturación Electronica es Obligatoria";
            error = true;
        }

        if (FEUser === "" || FEUser === undefined || FEUser === null) {
            errors.FEUser = "El Usuario del Endpoint de Facturación es Obligatorio";
            error = true;
        }
        
        if (FEPassword === "" || FEPassword === undefined || FEPassword === null) {
            errors.FEPassword = "La contraseña del Endpoint de Facturación es Obligatorio";
            error = true;
        }

        setErrors(errors);
        return error;
    }

    const updateProvider = async () => {
        setWarningModal(false);
        await ElectronicBillingHTTP.updateProvider(provider, FEResolution,FEUser,FEPassword,FEUrlEndpoint).then(response => {
            setSuccessModal(true);
        }).catch(err => {
            console.log(err);
            setErrorModal(true);
        });
    }

    return (
        <>
            <Row>
                <Col md={6}>
                    <TextField
                        id="select_invoice_provider"
                        label="Proveedor de Facturación Electronica"
                        select
                        value={provider}
                        className='medical-material-form__field'
                        onChange={(event) => {
                            handleChangeProvider(event.target.value);
                        }}
                        style={{ minWidth: '300px', maxWidth: '100%' }}
                        InputLabelProps={{
                            style: { color: '#646777' },
                            shrink: true
                        }}
                        error={errors.hasOwnProperty("provider") ? errors.provider !== "" : false}
                        helperText={errors.provider}
                    >
                        {providers.map((prov) => {
                            return <MenuItem key={prov.id_factura_electronica_api} value={prov.id_factura_electronica_api}>
                                {prov.proveedor}
                            </MenuItem>
                        })}
                    </TextField>
                    <br/><br/>
                </Col>
                <Col md={6}>
                    <TextField
                        id="autorizationCode"
                        label="Número de Autorización"
                        value={FEResolution}
                        className='medical-material-form__field'
                        onChange={(event) => {
                            handleChangeFEResolution(event.target.value);
                        }}
                        style={{ minWidth: '300px', maxWidth: '100%' }}
                        InputLabelProps={{
                            style: { color: '#646777' },
                            shrink: true
                        }}
                        error={errors.hasOwnProperty("FEResolution") ? errors.FEResolution !== "" : false}
                        helperText={errors.FEResolution}
                    />
                    <br/>  <br/>
                </Col>
                <Col md={6}>
                    <TextField
                        id="select_invoice_provider"
                        label="URL de Endpoint de Facturación"
                        value={FEUrlEndpoint}
                        className='medical-material-form__field'
                        onChange={(event) => {
                            setFEUrlEndpoint(event.target.value);
                        }}
                        style={{ minWidth: '300px', maxWidth: '100%' }}
                        InputLabelProps={{
                            style: { color: '#646777' },
                            shrink: true
                        }}
                        error={errors.hasOwnProperty("FEUrlEndpoint") ? errors.FEUrlEndpoint !== "" : false}
                        helperText={errors.FEUrlEndpoint}
                   />
                    <br/><br/>
                </Col>
                <Col md={6}>
                    <TextField
                        id="userElectronicBilling"
                        label="Usuario de F.E"
                        value={FEUser}
                        className='medical-material-form__field'
                        onChange={(event) => {
                            handleChangeFEUser(event.target.value);
                        }}
                        style={{ minWidth: '300px', maxWidth: '100%' }}
                        InputLabelProps={{
                            style: { color: '#646777' },
                            shrink: true
                        }}
                        error={errors.hasOwnProperty("FEUser") ? errors.FEUser !== "" : false}
                        helperText={errors.FEUser}
                    />
                    <br/>  <br/>
                </Col>
                <Col md={6}>
                    <TextField
                        id="passwordFE"
                        label="Contraseña de F.E"
                        value={FEPassword}
                        type="password"
                        className='medical-material-form__field'
                        onChange={(event) => {
                            handleChangeFEPassword(event.target.value);
                        }}
                        style={{ minWidth: '300px', maxWidth: '100%' }}
                        InputLabelProps={{
                            style: { color: '#646777' },
                            shrink: true
                        }}
                        error={errors.hasOwnProperty("FEPassword") ? errors.FEPassword !== "" : false}
                        helperText={errors.FEPassword}
                    />
                    <br/>  <br/>
                </Col>
                <Col md={12}>
                    <Button
                        style={{ margin: 20, marginLeft: 30 }}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            if(!validate())
                            {
                                setWarningModal(true);
                            }
                        }}
                    >
                        Guardar
                    </Button>
                </Col>
            </Row>

            <AlertModal
                color="warning"
                title="Esta seguro de cambiar la configuración de Facturación Electronica?"
                modal={warningModal}
                onOk={() => updateProvider()}
                toggle={() => cancelChangeProvider()}
            />

            <AlertModal
                color="success"
                title="Configuración de Facturación Electronica realizado Correctamente"
                modal={successModal}
                onOk={() => setSuccessModal(false)}
                toggle={() => setSuccessModal(false)}
            />

            <AlertModal
                color="danger"
                title="Ha ocurrido un error configurando la Facturación Electronica"
                modal={errorModal}
                onOk={() => setErrorModal(false)}
                toggle={() => setErrorModal(false)}
            />
        </>
    )
};

export default ElectronicBillingProvider;